export const reports = {category: 'Saskatchewan', reports: [{name:'Monthly Craft Producer Report',description:'',to:'provinces/SK/reports/MonhtlyCraftProducerReport',favourite:false}
                                                      ]};
